import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function DialogConfirmarEliminarBeneficioCampanha({
  open,
  onClose,
  confirmarEliminarBeneficio,
  beneficioParaEliminar,
}) {
  const temResultados = beneficioParaEliminar?.temResultadosAssociados === true;
  const totalResultados = beneficioParaEliminar?.totalResultadosAssociados || 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", sm: "520px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle>Confirmar eliminação</DialogTitle>

      <DialogContent>
        {temResultados ? (
          <MDTypography variant="body2">
            Este benefício já está associado a <strong>{totalResultados}</strong> resultado(s)
            calculado(s).
            <br />
            <br />
            Pretende eliminar também esses resultados associados?
          </MDTypography>
        ) : (
          <MDTypography variant="body2">Pretende eliminar este benefício?</MDTypography>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="error" onClick={confirmarEliminarBeneficio}>
          Eliminar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
